module.exports = __webpack_public_path__ + "static/media/user-marker.b0e8c0a6.png";